<template>
    <div class="info-page">
      <div class="home-page info-page">
        <Header></Header>
        <!-- 面包屑导航 -->
        <div class="breadcrumbs">
          <div class="breadcrumbs-content m_section_inner disflex">
            <div class="bd-ul">
              <ul class="">
                <li class="home"><a href="./">{{$t('home')}}</a></li>
                <li @click="back"><span>{{$t('Grammar')}}</span></li>
                <li><span>{{$t('Lessons')}} {{info.lesson_num}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_title">
          <div class="m_section_inner" style="background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(../../static/images/grammar-bg.jpg) no-repeat 0 0 / cover ">
            <div class="disflex sub-content">
              <div class="disflex topic-header">
                <div class="topic-titles">
                  <div class="jp">ぶんぽう</div>
                  <div class="jp">{{$t('Grammar')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grammar-content">
          <h2 class="step1 mt20 disflex" style="font-size: 26px;font-weight: 400;margin-left: 30px;">
            <div class="step1-num text-shadow">L{{info.lesson_num}}</div>
            <div class="step1-content">
              <div><strong>{{$t('Lessons')}} {{info.lesson_num}}</strong></div>
              <span>{{ info.title_en }}</span>
            </div>
          </h2>
          <div class="mt20">
            <img :src="info.cover_image" class="w100" />
          </div>
          <div class="grammar-detail">
            <div class="t bd" style="padding: 20px 0;">{{info.desc_en}}</div>
            <div class="Key-phrase bd" style="padding: 20px 0;">
              <div class="title">{{$t('Key_phrase')}}:</div>
              <div class="Key-phrase-b">{{info.key_phrases}}</div>
            </div>
            <div class="scripts" style="padding: 20px 0;">
              <div class="title">{{$t('Scripts')}}</div>
              <div class="scripts-content" style="padding: 20px 0;">
                <ul>
                  <li v-for="(item,index) in info.dialogue_data">
                    <div class="left">
                      <div class="ri">{{item.speak_1_jp}}</div>
                      <div class="pin">{{item.speak_2_en}}</div>
                    </div>
                    <div class="right">
                      <div class="ri">{{item.content_jp}}</div>
                      <div class="pin cr8a570f"><em>{{item.content_yin}}</em></div>
                      <div class="en">{{item.content_en}}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="tips-content">
            <div class="title">{{$t('grammar_tips')}}</div>
            <div class="teacher_data">
              <div class="" v-html="info.teacher_data"></div>
            </div>
          </div>
        </div>
      </div>
      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Grammar_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>
	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import md5 from '../../static/js/md5.min.js'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        info:{},
        id:'',
        startTime: 0,
        totalWatchTime: 0,
        reportingInterval: null,
        videoElement: this.$refs.videoPlayer
      }
    },
    mounted() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeDestroy() {
      // Clean up event listeners
      clearInterval(this.reportingInterval);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },

    watch: {
      '$route'(to, from) {
        if (to.query.id !== from.query.id) {
          this.id = to.query.id;
          this.getList();
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        videoPlayer.pause();
        videoPlayer.currentTime = 0;
      }
      next();  // 继续导航
    },
	created(){
    this.id = this.$route.query.id
    this.videoElement = this.$refs.videoPlayer;
    this.getList()
	},
    methods: {
      back(){
      	this.$router.push({path:'/Grammar'});
      },
      getToNav(item){
        if (this.$route.query.id == item.id) {
          return;
        }
        if(this.$refs.videoPlayer) {
          this.$refs.videoPlayer.play()
          this.$refs.videoPlayer.currentTime = 0
          this.$refs.videoPlayer.src = '';
        }
        this.$router.push({path:'/GrammarDetail',query: {id:item.id}});
        this.id = item.id
        this.getList();
      },
      getList(){
        let that = this
        let data = {
          "id":this.id
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/grammar/detail',data,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            if (r.data.user_level < 2){
              that.$refs.levelDialog.showMaskFun();
            }else {
              that.info = r.data
            }
          })
        })
      },
      //播放时间
      reportWatchTime(force = false, finished = false) {
        const now = Date.now();
        let currentWatch = (now - this.startTime) / 1000;
        this.totalWatchTime += currentWatch;
        this.startTime = now;
        // Don't report if watch time is less than 5 seconds (unless forced)
        if (!force && currentWatch < 5) return;
        let that = this
        let ts = Date.now();
        let seconds = Math.round(this.totalWatchTime);
        let sign = that.generateSign(seconds, ts);
        let data = {
          video_id: this.id,
          seconds: seconds,
          finished: finished,
          video_type: 'mooc',
          ts: ts,
          sign: sign
        }
        that.$api.post('/api/watch/report_time',data,r =>{
          that.$parent.returnCode(r,function(){

          })
        })
      },
      generateSign(score, ts, secret = "jksdfuiAa4so") {
        const str = String(score) + String(ts) + secret
        return md5(str);
      },
      // Check if we should count time (tab visible, playing normally at 1x speed)
      canCountTime() {
        return !document.hidden &&
          !this.videoElement.paused &&
          this.videoElement.playbackRate === 1.0;
      },

      // Start the reporting interval
      startReporting() {
        this.startTime = Date.now();
        if (this.reportingInterval) clearInterval(this.reportingInterval);

        this.reportingInterval = setInterval(() => {
          if (this.canCountTime()) {
            this.reportWatchTime();
          }
        }, 10000); // Report every 10 seconds
      },

      // Event handlers
      onPlay() {
        console.log('开始播放');
        this.videoElement = this.$refs.videoPlayer;
        if (!this.videoElement) return;
        if (this.videoElement.playbackRate !== 1.0) {

          this.videoElement.pause();
          return;
        }
        this.startReporting();
      },

      onPause() {
        console.log('暂停播放');
        if (this.canCountTime()) {
          this.reportWatchTime();
        }
        clearInterval(this.reportingInterval);
      },

      onEnded() {
        console.log('播放结束');
        this.reportWatchTime(true, true); // Force report and mark as finished
        clearInterval(this.reportingInterval);
      },

      onSeeking() {
        console.log('拖动进度条');
        // Reset timer when seeking to prevent cheating
        this.startTime = Date.now();
      },

      onRateChange() {
        console.log('倍速播放');
        this.videoElement = this.$refs.videoPlayer;
        if (this.videoElement.playbackRate !== 1.0) {

          this.videoElement.pause();
        }
      },

      handleVisibilityChange() {
        this.videoElement = this.$refs.videoPlayer;
        if (document.hidden) {
          this.reportWatchTime(true);
          clearInterval(this.reportingInterval);
        } else if (!this.videoElement.paused) {
          this.startReporting();
        }
      },

      handleBeforeUnload() {
        this.reportWatchTime(true);
      },
      closeBuyPopup(){
        this.$refs.levelDialog.closeMask();
        this.$router.push({path:'/',query: {}});
      },
      statusText(status) {
        switch (status) {
          case 1: return this.$t('no_start')
          case 2: return this.$t('in_process')
          case 3: return this.$t('finished')
          default: return ''
        }
      }
	}
}
</script>
<style scoped>
.sure_btn{
  display: block;
  width: 70%;           /* 按钮宽度，手机上也合适 */
  max-width: 600px;     /* 最大宽度 */
  margin: 20px auto 0;  /* 居中并有间距 */
  padding: 12px 0;      /* 内边距控制高度 */
  font-size: 18px;      /* 字体大小适中 */
  line-height: normal;  /* 去掉原来的103px */
  background: url('../../static/images/level_button.png') no-repeat center;
  background-size: contain;  /* 图片自适应容器 */
  text-align: center;
  color: #fff;
  text-shadow: 2px 2px 0 #001d8c;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}
.img-box {
  position: relative;
  display: inline-block;
}
.img-box img {
  display: block;
  width: 100%;
  border-radius: 8px;
}
.status-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 8px 20px;
  font-size: 25px;
  color: #fff;

  border-radius: 12px;
}
/* 不同状态颜色 */
.status-1 {
  background: #fd5959;
}
.status-2 {
  background: #fd9901;
}
.status-3 {
  background: #00f474;
}
</style>



// WEBPACK FOOTER //
// src/page/GrammarDetail.vue